import { render } from "./NodeShowEmbed.vue?vue&type=template&id=c5776002&ts=true"
import script from "./NodeShowEmbed.vue?vue&type=script&lang=ts"
export * from "./NodeShowEmbed.vue?vue&type=script&lang=ts"

import "./NodeShowEmbed.vue?vue&type=style&index=0&id=c5776002&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__